import XApi from '../../utils/Api';
import XEndpoints from '../../core/config/Endpoints';

export class AuthService {
  async login(email: string, password: string) {
    const response = await XApi.post(XEndpoints.login, {
      email,
      password,
    }, {
      'Content-Type': 'application/json',
    });
    return response ?? null;
  }

  async refreshToken() {
    const token = localStorage.getItem('token');
    if (token) {
      const response = await XApi.get(XEndpoints.refreshToken, {
        'Content-Type': 'application/json',
        'Authorization': token,
      });

      return response ?? null;
    }
    return null;
  }

  async updateProfile({ email, name, profilePic, phoneNumber, password, whatsapp, addressLine1, addressLine2, city, state, country, zipCode }: {
    email: string,
    name: string,
    profilePic?: string,
    phoneNumber?: string
    password?: string,
    whatsapp?: string,
    addressLine1?: string,
    addressLine2?: string,
    city?: string,
    state?: string,
    country?: string,
    zipCode?: string,
  }) {
    const token = localStorage.getItem('token');
    if (token) {
      const response = await XApi.patch(XEndpoints.updateProfile, {
        email,
        name,
        profilePic,
        phoneNumber,
        ...(password && { password }),
        ...(whatsapp && { whatsapp }),
        ...(addressLine1 && { addressLine1 }),
        ...(addressLine2 && { addressLine2 }),
        ...(city && { city }),
        ...(state && { state }),
        ...(country && { country }),
        ...(zipCode && { zipCode }),
      }, {
        'Content-Type': 'application/json',
        'Authorization': token,
      });
      return response ?? null;
    }
    return null;
  }

  async allModules() {
    const response = await XApi.get(XEndpoints.allModules, {
      'Content-Type': 'application/json',
    });

    return response ?? null;
  }
}
